document.addEventListener('DOMContentLoaded', () => {

	// console.log('project');
	// $('.gallery-thumbs .video-thumb').on('click', ({ target }) => {
	// 	console.log(target);
	// });

	const galleryThumbs = new Swiper('.gallery-thumbs', {
		spaceBetween: 10,
		slidesPerView: 2,
		freeMode: true,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		nested: true,
		breakpoints: {
			1025: {
				slidesPerView: 6,
			}
		}
	});
	const galleryTop = new Swiper('.gallery-top', {
		spaceBetween: 10,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		thumbs: {
			swiper: galleryThumbs
		}
	});
	// galleryTop.on('slideChange', function (e) {
		// const $frame = $(e.el).find('iframe').get(0);
		// console.dir($(e.el).find('iframe').get(0));
	// });
});